export const graph1 = [
  {
    gimmicky: 18,
    bluebonnet: 10,
    kwh: 500,
  },
  {
    gimmicky: 15,
    bluebonnet: 10,
    kwh: 1000,
  },
  {
    gimmicky: 4,
    bluebonnet: 10,
    kwh: 1500,
  },
  {
    gimmicky: 15,
    bluebonnet: 10,
    kwh: 2000,
  },
  {
    gimmicky: 18,
    bluebonnet: 10,
    kwh: 2500,
  },
];

export const monthTicks = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const graph2 = [
  {
    name: "Jan",
    gimmicky: 90,
    bluebonnet: 60,
  },
  {
    name: "Feb",
    gimmicky: 150,
    bluebonnet: 120,
  },
  {
    name: "Mar",
    gimmicky: 170,
    bluebonnet: 100,
  },
  {
    name: "Apr",
    gimmicky: 90,
    bluebonnet: 150,
  },
  {
    name: "May",
    gimmicky: 140,
    bluebonnet: 160,
  },
  {
    name: "Jun",
    gimmicky: 180,
    bluebonnet: 200,
  },
  {
    name: "Jul",
    gimmicky: 200,
    bluebonnet: 190,
  },
  {
    name: "Aug",
    gimmicky: 250,
    bluebonnet: 200,
  },
  {
    name: "Sep",
    gimmicky: 240,
    bluebonnet: 179,
  },
  {
    name: "Oct",
    gimmicky: 230,
    bluebonnet: 190,
  },
  {
    name: "Nov",
    gimmicky: 228,
    bluebonnet: 149,
  },
  {
    name: "Dec",
    gimmicky: 170,
    bluebonnet: 148,
  },
];

export const graph3 = [
  {
    name: "Jan",
    usage: 768,
  },
  {
    name: "Feb",
    usage: 975,
  },
  {
    name: "Mar",
    usage: 800,
  },
  {
    name: "Apr",
    usage: 898,
  },
  {
    name: "May",
    usage: 1189,
  },
  {
    name: "Jun",
    usage: 1239,
  },
  {
    name: "Jul",
    usage: 1149,
  },
  {
    name: "Aug",
    usage: 1010,
  },
  {
    name: "Sep",
    usage: 1300,
  },
  {
    name: "Oct",
    usage: 870,
  },
  {
    name: "Nov",
    usage: 720,
  },
  {
    name: "Dec",
    usage: 690,
  },
];

export const graphLabelArray = {
  "bluebonnet-vs-ev-charging": [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
  ],
  "bluebonnet-vs-free-nights": [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
  ],
  "bluebonnet-vs-free-weekends": [
    "Mon",
    "Tues",
    "Wed",
    "Thurs",
    "Fri",
    "Sat",
    "Sun",
  ],
  other: ["0kWh", "500kWh", "1000kWh", "1500kWh", "2000kWh", "2500kWh"],
};

export const graphMockData = {
  "bluebonnet-vs-ev-charging": [
    {
      gimmicky: 12.4,
      bluebonnet: 13,
      hour: 0,
    },
    {
      gimmicky: 12.4,
      bluebonnet: 13,
      hour: 1,
    },
    {
      gimmicky: 12.4,
      bluebonnet: 13,
      hour: 2,
    },
    {
      gimmicky: 12.4,
      bluebonnet: 13,
      hour: 3,
    },
    {
      gimmicky: 12.4,
      bluebonnet: 13,
      hour: 4,
    },
    {
      gimmicky: 14.4,
      bluebonnet: 13,
      hour: 5,
    },
    {
      gimmicky: 14.4,
      bluebonnet: 13,
      hour: 6,
    },
    {
      gimmicky: 14.4,
      bluebonnet: 13,
      hour: 7,
    },
    {
      gimmicky: 14.4,
      bluebonnet: 13,
      hour: 8,
    },
    {
      gimmicky: 14.4,
      bluebonnet: 13,
      hour: 9,
    },
    {
      gimmicky: 14.4,
      bluebonnet: 13,
      hour: 10,
    },
    {
      gimmicky: 14.4,
      bluebonnet: 13,
      hour: 11,
    },
    {
      gimmicky: 14.4,
      bluebonnet: 13,
      hour: 12,
    },
    {
      gimmicky: 14.4,
      bluebonnet: 13,
      hour: 13,
    },
    {
      gimmicky: 14.4,
      bluebonnet: 13,
      hour: 14,
    },
    {
      gimmicky: 14.4,
      bluebonnet: 13,
      hour: 15,
    },
    {
      gimmicky: 14.4,
      bluebonnet: 13,
      hour: 16,
    },
    {
      gimmicky: 14.4,
      bluebonnet: 13,
      hour: 17,
    },
    {
      gimmicky: 14.4,
      bluebonnet: 13,
      hour: 18,
    },
    {
      gimmicky: 14.4,
      bluebonnet: 13,
      hour: 19,
    },
    {
      gimmicky: 14.4,
      bluebonnet: 13,
      hour: 20,
    },
    {
      gimmicky: 12.4,
      bluebonnet: 13,
      hour: 21,
    },
    {
      gimmicky: 12.4,
      bluebonnet: 13,
      hour: 22,
    },
    {
      gimmicky: 12.4,
      bluebonnet: 13,
      hour: 23,
    },
    {
      gimmicky: 12.4,
      bluebonnet: 13,
      hour: 24,
    },
  ],
  "bluebonnet-vs-free-nights": [
    {
      gimmicky: 0,
      bluebonnet: 13,
      hour: 0,
    },
    {
      gimmicky: 0,
      bluebonnet: 13,
      hour: 1,
    },
    {
      gimmicky: 0,
      bluebonnet: 13,
      hour: 2,
    },
    {
      gimmicky: 0,
      bluebonnet: 13,
      hour: 3,
    },
    {
      gimmicky: 0,
      bluebonnet: 13,
      hour: 4,
    },
    {
      gimmicky: 16.5,
      bluebonnet: 13,
      hour: 5,
    },
    {
      gimmicky: 16.5,
      bluebonnet: 13,
      hour: 6,
    },
    {
      gimmicky: 16.5,
      bluebonnet: 13,
      hour: 7,
    },
    {
      gimmicky: 16.5,
      bluebonnet: 13,
      hour: 8,
    },
    {
      gimmicky: 16.5,
      bluebonnet: 13,
      hour: 9,
    },
    {
      gimmicky: 16.5,
      bluebonnet: 13,
      hour: 10,
    },
    {
      gimmicky: 16.5,
      bluebonnet: 13,
      hour: 11,
    },
    {
      gimmicky: 16.5,
      bluebonnet: 13,
      hour: 12,
    },
    {
      gimmicky: 16.5,
      bluebonnet: 13,
      hour: 13,
    },
    {
      gimmicky: 16.5,
      bluebonnet: 13,
      hour: 14,
    },
    {
      gimmicky: 16.5,
      bluebonnet: 13,
      hour: 15,
    },
    {
      gimmicky: 16.5,
      bluebonnet: 13,
      hour: 16,
    },
    {
      gimmicky: 16.5,
      bluebonnet: 13,
      hour: 17,
    },
    {
      gimmicky: 16.5,
      bluebonnet: 13,
      hour: 18,
    },
    {
      gimmicky: 16.5,
      bluebonnet: 13,
      hour: 19,
    },
    {
      gimmicky: 16.5,
      bluebonnet: 13,
      hour: 20,
    },
    {
      gimmicky: 0,
      bluebonnet: 13,
      hour: 21,
    },
    {
      gimmicky: 0,
      bluebonnet: 13,
      hour: 22,
    },
    {
      gimmicky: 0,
      bluebonnet: 13,
      hour: 23,
    },
    {
      gimmicky: 0,
      bluebonnet: 13,
      hour: 24,
    },
  ],
  "bluebonnet-vs-free-weekends": [
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 0,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 1,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 2,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 3,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 4,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 5,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 6,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 7,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 8,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 9,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 10,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 11,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 12,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 13,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 14,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 15,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 16,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 17,
    },
    {
      gimmicky: 15.2,
      bluebonnet: 13,
      hour: 18,
    },
    {
      gimmicky: 0,
      bluebonnet: 13,
      hour: 19,
    },
    {
      gimmicky: 0,
      bluebonnet: 13,
      hour: 20,
    },
    {
      gimmicky: 0,
      bluebonnet: 13,
      hour: 21,
    },
    {
      gimmicky: 0,
      bluebonnet: 13,
      hour: 22,
    },
    {
      gimmicky: 0,
      bluebonnet: 13,
      hour: 23,
    },
    {
      gimmicky: 0,
      bluebonnet: 13,
      hour: 24,
    },
  ],
};

export const bluebonnetVsEvChargingData = [
  {
    gimmicky: 12.4,
    bluebonnet: 13,
    hour: 0,
  },
  {
    gimmicky: 12.4,
    bluebonnet: 13,
    hour: 1,
  },
  {
    gimmicky: 12.4,
    bluebonnet: 13,
    hour: 2,
  },
  {
    gimmicky: 12.4,
    bluebonnet: 13,
    hour: 3,
  },
  {
    gimmicky: 12.4,
    bluebonnet: 13,
    hour: 4,
  },
  {
    gimmicky: 14.4,
    bluebonnet: 13,
    hour: 5,
  },
  {
    gimmicky: 14.4,
    bluebonnet: 13,
    hour: 6,
  },
  {
    gimmicky: 14.4,
    bluebonnet: 13,
    hour: 7,
  },
  {
    gimmicky: 14.4,
    bluebonnet: 13,
    hour: 8,
  },
  {
    gimmicky: 14.4,
    bluebonnet: 13,
    hour: 9,
  },
  {
    gimmicky: 14.4,
    bluebonnet: 13,
    hour: 10,
  },
  {
    gimmicky: 14.4,
    bluebonnet: 13,
    hour: 11,
  },
  {
    gimmicky: 14.4,
    bluebonnet: 13,
    hour: 12,
  },
  {
    gimmicky: 14.4,
    bluebonnet: 13,
    hour: 13,
  },
  {
    gimmicky: 14.4,
    bluebonnet: 13,
    hour: 14,
  },
  {
    gimmicky: 14.4,
    bluebonnet: 13,
    hour: 15,
  },
  {
    gimmicky: 14.4,
    bluebonnet: 13,
    hour: 16,
  },
  {
    gimmicky: 14.4,
    bluebonnet: 13,
    hour: 17,
  },
  {
    gimmicky: 14.4,
    bluebonnet: 13,
    hour: 18,
  },
  {
    gimmicky: 14.4,
    bluebonnet: 13,
    hour: 19,
  },
  {
    gimmicky: 14.4,
    bluebonnet: 13,
    hour: 20,
  },
  {
    gimmicky: 12.4,
    bluebonnet: 13,
    hour: 21,
  },
  {
    gimmicky: 12.4,
    bluebonnet: 13,
    hour: 22,
  },
  {
    gimmicky: 12.4,
    bluebonnet: 13,
    hour: 23,
  },
  {
    gimmicky: 12.4,
    bluebonnet: 13,
    hour: 24,
  },
];
